module.exports = __webpack_public_path__ + "img/wms.b5d1a46.png";


//////////////////
// WEBPACK FOOTER
// ./static/wms.png
// module id = Nnx3
// module chunks = 1 3